import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  heightScreen: number = window.innerHeight;
  private heightScreenBs: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerHeight);
  heightScreen$ = this.heightScreenBs.asObservable();

  constructor() { }

  updateHeightScreen(height: number) {
    this.heightScreenBs.next(height);
  }
}
